<template>
  <a-card size="small" title="筛选条件">
    <a-form-model :label-col="labelCol" class="search-form" label-align="left">
      <a-form-model-item label="时间">
        <a-range-picker v-model="checkedDate" :default-value="checkedDate" :allow-clear="false" />
      </a-form-model-item>
      <a-form-model-item label="项目">
        <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange"> 全部</a-checkbox>
        <a-checkbox-group v-model="checkedProjectList" @change="onChangeProject">
          <a-checkbox v-for="project in projects" :key="project.id" :value="project.id" name="type"> {{ project.name }} </a-checkbox>
        </a-checkbox-group>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import moment from 'moment';
import { projectList } from '@/api/project/project';

export default {
  name: 'DataFilter',
  data() {
    return {
      checkedDate: [moment().subtract(1, 'month').add(1, 'day'), moment()],
      checkedProjectList: [],
      labelCol: { span: 1 },
      wrapperCol: {},
      checkAll: true,
      indeterminate: false,
      plainOptions: [],
      projects: []
    };
  },

  computed: {
    filter() {
      const { checkedDate, checkedProjectList } = this;
      return {
        checkedDate,
        checkedProjectList
      };
    }
  },

  watch: {
    filter() {
      this.$emit('change', this.checkedDate, this.checkedProjectList);
    }
  },
  created() {
    this.getProjectList();
  },

  methods: {
    onChangeProject(checkedList) {
      this.indeterminate = !!checkedList.length && checkedList.length < this.projects.length;
      this.checkAll = checkedList.length === this.projects.length;
    },

    onCheckAllChange(e) {
      this.checkedProjectList = e.target.checked
        ? this.projects.map(project => {
          return project.id;
        })
        : [];
      this.indeterminate = false;
      this.checkAll = e.target.checked;
    },
    // 获取项目列表
    getProjectList() {
      projectList({}).then(res => {
        this.projects = res.data.projects;
        this.checkedProjectList = this.projects.map(project => {
          return project.id;
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0px;
  border-bottom: silver 1px dashed;
}
</style>
